var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9193 9.94524L0.327318 17.5373C-0.109199 17.9738 -0.109013 18.6814 0.327318 19.1179C0.763836 19.5544 1.47148 19.5544 1.90798 19.1179L9.49997 11.5259L17.092 19.1179C17.5285 19.5544 18.2361 19.5544 18.6726 19.1179C19.1091 18.6814 19.1091 17.9738 18.6726 17.5373L11.0806 9.94524L18.6726 2.35323C19.1089 1.91671 19.1089 1.20907 18.6726 0.772562C18.2361 0.336231 17.5285 0.336231 17.092 0.772562L9.49997 8.36457L1.90798 0.772562C1.47147 0.336231 0.763821 0.336231 0.327318 0.772562C-0.109013 1.20908 -0.109013 1.91673 0.327318 2.35323L7.9193 9.94524Z",
    fill: "#778CA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseicon);
export default __webpack_public_path__ + "static/media/closeicon.c37c88a11284d397699e9a4f1faf5eb4.svg";
export { ForwardRef as ReactComponent };